import React from "react";
import { useHistory, withRouter } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

const Auth0ProviderWithHistory = ({ children }) => {
  const domain = process.env.AUTH0_DOMAIN;
  const clientId = process.env.AUTH0_CLIENT_ID;

  const history = useHistory();

  const onRedirectCallback = (appState) => {
    history.push(appState?.returnTo || window.location.pathname);
    history.go(0);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      audience='https://api.themorningcontext.com/api/v1'
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      cacheLocation={"localstorage"}
      useRefreshTokens={true}
      scope="openid profile email offline_access"
      useCookiesForTransactions={true}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;